module.exports = __webpack_public_path__ + "img/mieszkanko.7d92fa01.jpg";